// batch AI generation subtitle modal
import _ from 'lodash'

export default {
  data() {
    return {
      isBatch: false,
      batchTotalPrice: 0,
      batchSubConfig: [],
      batchAllVideosCount: 0,
      subsAlreadyExists: false,
      loadingConfigs: false,
      batchMetadata: null,
    }
  },
  mounted() {
    this.$root.$on('openBatchSubModal', () => {
      this.$root.$emit('openSubtitleModal', {
        videoId: '',
        initialState: true,
        isBatch: true,
      })
    })

    this.$root.$on('batchAllVideosCount', (batchAllVideosCount) => {
      this.batchAllVideosCount = batchAllVideosCount
    })
    this.$root.$on('subsAlreadyExists', (subsAlreadyExists) => {
      this.subsAlreadyExists = subsAlreadyExists
    })
    this.$root.$on('loadingConfigs', (loadingConfigs) => {
      this.loadingConfigs = loadingConfigs
    })
    this.$root.$on('processQueue', () => {
      this.processSubtitleQueue()
    })
    this.$root.$on('handleBatchConfigs', (configuredVideos) => {
      this.handleBatchSubConfigs(configuredVideos)
    })
    this.$root.$on('batchGenerationMetadata', (batchMetadata) => {
      this.handleBatchMetadata(batchMetadata)
    })
  },
  beforeDestroy() {
    this.$root.$off('openBatchSubModal')
    this.$root.$off('batchAllVideosCount')
    this.$root.$off('subsAlreadyExists')
    this.$root.$off('loadingConfigs')
    this.$root.$off('processQueue')
    this.$root.$off('handleBatchConfigs')
    this.$root.$off('batchGenerationMetadata')
  },
  computed: {
    filterSubsToGenerate() {
      const batchSubConfig = this.batchSubConfig
      let filter = []
      batchSubConfig.map((video) => {
        const filteredLangToGenerate = this.checkExistingSubs(
          this.generateSubtitleData,
          video
        )
        if (filteredLangToGenerate) {
          filteredLangToGenerate.subtitleFromAiOption =
            video.subtitleFromAiOption
          if (filteredLangToGenerate.subtitleFromAiOption) {
            filteredLangToGenerate.subtitleLabelFromAnotherExistingOne =
              video.subtitles[0]
          }
          const subConfig = {
            video_id: video.id,
            folder_id: video.folder_id,
            title: video.title,
            config: filteredLangToGenerate,
            status: 'pending',
            type: 'subtitle',
            original_lang: video.original_lang,
            video_length: video.length,
          }
          filter.push(subConfig)
        }
      })
      return filter
    },
    handleExistingSubs() {
      const batchSubConfig = this.batchSubConfig
      for (let video of batchSubConfig) {
        const subsToGenerate = this.checkExistingSubs(
          this.generateSubtitleData,
          video
        )
        if (subsToGenerate) {
          return false
        }
      }
      return true
    },
  },
  watch: {
    'generateSubtitleData.selectedItems': {
      deep: true,
      handler() {
        this.batchTotalPrice = this.calculateFinalPrice(
          this.filterSubsToGenerate
        )
      },
    },
  },
  methods: {
    formatSrcLang(incomingLabel) {
      if (
        incomingLabel === 'pt-BR' ||
        incomingLabel === 'pt-br' ||
        incomingLabel === 'pt'
      )
        return 'pt-BR'
      return incomingLabel
    },
    async handleOpenBatchSubGenerationModal() {
      this.generateSubtitleDataInitial = _.cloneDeep(this.generateSubtitleData)
      this.subtitles = []
      this.open = true

      if (this.planInfo.currency) {
        if (this.planInfo.currency === 'brl') {
          this.generateSubtitleData.subtitleSrcLangFromVideo = 'pt-BR'
        } else {
          this.generateSubtitleData.subtitleSrcLangFromVideo = 'en'
        }
      }
      this.handleUpdateModalStage({
        globalStage: 'generate',
        subStage: 1,
      })
    },
    checkExistingSubs(subtitlesToGenerate, subtitleObj) {
      const filteredSelectedItems = subtitlesToGenerate.selectedItems.filter(
        (selectedItem) =>
          !subtitleObj.subtitles.some(
            (sub) => this.formatSrcLang(sub) === selectedItem.srclang
          )
      )

      return filteredSelectedItems.length > 0
        ? { ...subtitlesToGenerate, selectedItems: filteredSelectedItems }
        : null
    },
    handleBatchSubConfigs(videos) {
      const batchSubConfig = videos.map((obj) => ({
        id: obj.id,
        title: obj.title,
        folder_id: obj.folder_id,
        length: obj.length,
        subtitles: obj.subtitles ?? [],
        original_lang: obj.original_lang,
        subtitleFromAiOption: obj.subtitles && obj.subtitles.length > 0 ? 1 : 0,
      }))
      this.batchSubConfig = batchSubConfig
    },
    handleBatchSubtitleOptions() {
      const existingSubtitles = this.batchSubConfig.map((obj) =>
        obj.subtitles.map((sub) => sub.srclang)
      )

      const languageOptions = this.availableAiLangCodes

      const filteredLanguageOptions = languageOptions.filter(
        (option) => !existingSubtitles.flat().includes(option.srclang)
      )

      return filteredLanguageOptions
    },
    setUpDataToCalc(queue_data) {
      const setted_queue = queue_data.map((obj) => {
        return {
          subs_to_queue: obj.config.selectedItems.length,
          minutes: Math.floor(obj.video_length / 60),
          seconds: Math.floor(obj.video_length % 60),
        }
      })
      return setted_queue
    },
    calculateFinalPrice(queue_data) {
      let final_price = 0
      const filtered_data = this.setUpDataToCalc(queue_data)
      filtered_data.forEach((obj, index) => {
        const credits_per_video = this.applyCreditsCalcRule(obj)
        const price_per_video = obj.subs_to_queue * credits_per_video
        if (this.batchSubConfig[index])
          this.batchSubConfig[index].price_per_video = price_per_video
        final_price += price_per_video
      })
      return final_price
    },
    applyCreditsCalcRule(obj) {
      let roundPriceUp = null
      if (obj.minutes < 5) return 1

      const remainder = obj.minutes % 5
      if (remainder !== 0) {
        roundPriceUp = true
      } else {
        roundPriceUp = obj.seconds > 0
      }
      const creditsPerMin = Math.floor(obj.minutes / 5)
      const credits_per_video = roundPriceUp ? creditsPerMin + 1 : creditsPerMin
      return credits_per_video
    },
    _hasEnoughCredits(queue) {
      const filtered_data = this.setUpDataToCalc([queue])
      const credits_per_video = this.applyCreditsCalcRule(filtered_data[0])
      const final_price = filtered_data[0].subs_to_queue * credits_per_video
      const remainingCredits = this.accountBalance - final_price

      if (remainingCredits < 0) {
        return false
      }
      return true
    },
    async handleBatchSubGeneration() {
      const subsToGenerate = this.filterSubsToGenerate
      if (!subsToGenerate.length) {
        this.$root.$emit('subsAlreadyExists', true)
        return
      }
      this.$root.$emit('subsAlreadyExists', false)
      try {
        subsToGenerate.map(async (subConfig) => {
          if (subConfig) {
            await window.db.AI_batch_queue.add(subConfig)
          }
        })
        this.$root.$emit('ai-process-started')
        setTimeout(() => {
          this.processSubtitleQueue()
        }, 100)
      } catch (error) {
        console.error('Error to queue subtitle: ', error)
      }
    },
    async processSubtitleQueue() {
      let loopCount = 0

      const pendingItems = await window.db.AI_batch_queue.where({
        status: 'pending',
      }).toArray()

      for (const item of pendingItems) {
        const hasEnoughCredits = this._hasEnoughCredits(item)
        if (!hasEnoughCredits) {
          await window.db.AI_batch_queue.clear()
          return
        }
        try {
          await window.db.AI_batch_queue.update(item.id, {
            status: 'generating',
          })

          this.videoId = item.video_id
          this.generateSubtitleData = { ...item.config }

          await this.handlePostAiGeneratedSubtitle()

          await window.db.AI_batch_queue.update(item.id, {
            metadata: this.batchMetadata,
          })

          this.$root.$emit('updateGeneratingIds', item.video_id)

          if (!loopCount) {
            loopCount += 1
            this.$root.$emit('fetchQueueStatus')
          }

          this.$root.$emit('handleVideoAiWorkflow')
        } catch (error) {
          console.error(`Error to generate subtitle ${item.video_id}: `, error)

          await window.db.AI_batch_queue.update(item.id, {
            status: 'error',
          })

          this.$root.$emit('verifyIfHasError')
        }
      }
    },
    handleBatchMetadata(batchMetadata) {
      const id = batchMetadata.id

      const dependent_works = batchMetadata?.metadata?.dependent_works
      const metadataConfig = {
        id,
        dependent_works,
      }
      this.batchMetadata = metadataConfig
    },
  },
}
